import type { ChangePasswordResult } from './ChangePasswordForm'

// Base URL and token are passed in so this stays inside the typed island
// (apiConfig and utils/auth are untyped JS).
export async function changePasswordRequest(
  baseUrl: string,
  token: string | null,
  currentPassword: string,
  newPassword: string,
): Promise<ChangePasswordResult> {
  if (!token) {
    return { success: false, error: 'Your session has ended. Sign in again to change your password.' }
  }
  const res = await fetch(`${baseUrl}/api/auth/coordinator/change-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  })
  const body = await res.json().catch(() => ({}))
  if (res.ok && body.success === true) {
    // The change revokes every earlier session, this one included; the server re-issues ours.
    return typeof body.token === 'string' && body.token ? { success: true, token: body.token } : { success: true }
  }
  return { success: false, error: typeof body.error === 'string' ? body.error : undefined }
}
